import Vue from 'vue';
import App from './App';
import VueRouter from 'vue-router';
import Home from './Home.vue';
import Executive from './Executive.vue';
import Faculty from './Faculty.vue';
import Officers from './Officers.vue';
import Staff from './Staff.vue';
import Single from './Single.vue';
import NotFound from './NotFound.vue';
import Vcprofile from './Vcprofile.vue';

import vueSmoothScroll from 'vue2-smooth-scroll'

import VueMeta from 'vue-meta';
Vue.use(VueMeta)

Vue.use(vueSmoothScroll)

var VueScrollactive = require('vue-scrollactive');
Vue.use(VueScrollactive);

Vue.use(VueRouter)


const routes = [
  {path: '/', component: Home},
  {path: '/executive', component: Executive},
  {path: '/faculty', component: Faculty},
  {path: '/officers', component: Officers},
  {path: '/staff', component: Staff},
  // {path: '/sislamk', component: Vcprofile},
  {path: '/:slug', component: Single},
  {path: '*', component: NotFound},
]

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
const router = new VueRouter({
  routes,
  mode: 'history',

  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  linkActiveClass: 'is-active',
  linkExactActiveClass: "is-active"

})

new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js